import { AxiosRequest } from "_services/api";
import { toastErro } from "components/Toast";
import { useEffect, useMemo, useState } from "react";
import { mensagemDeErro } from "../../SolicitacaoPlaca/utils/mensagemDeErro";
import { IFornecedorTerceiros } from "../interfaces/IFornecedorTerceiros";

export function useFornecedoresTerceiros() {
  const msAw = useMemo(
    () => AxiosRequest.makeApi(process.env.REACT_APP_MS_AW),
    []
  );
  const [fornecedores, setFornecedores] = useState<IFornecedorTerceiros[]>([]);
  const [carregando, setCarregando] = useState(true);

  useEffect(() => {
    msAw
      .get("/solicitacao-placa/terceiros/fornecedores")
      .then(({ data }) => setFornecedores(data ?? []))
      .catch((erro) => {
        setFornecedores([]);
        toastErro(mensagemDeErro(erro, "Erro ao buscar os fornecedores"));
      })
      .finally(() => setCarregando(false));
  }, [msAw]);

  return { fornecedores, carregando };
}
